import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { GeneralService } from '../services/general.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const generalService = inject(GeneralService);
  const authService = inject(AuthService);
  let isRefreshing = false;
  const refreshTokenSubject = new BehaviorSubject<string | null>(null);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('🔥 ErrorInterceptor:', error);

      // 🌐 Error de red / CORS / backend caído
      if (error.status === 0) {
        generalService.viewSnacAlert(
          'No se pudo conectar con el servidor',
          'error',
          'Error de red',
        );
        return throwError(() => error);
      }

      // 🔐 No autorizado
      // if (error.status === 401) {
      //   // generalService.viewSnacAlert(error.error.message, 'alert', 'Acceso no autorizado');
      //   const refreshToken = localStorage.getItem('refreshToken');
      //   const token = localStorage.getItem('token');

      //   return authService
      //     .refreshToken({
      //       token: token || '',
      //       refreshToken: refreshToken || '',
      //       isWeb: true,
      //     })
      //     .pipe(
      //       switchMap((response) => {
      //         if (!response?.token) {
      //           return throwError(() => error);
      //         }
      //         localStorage.setItem('token', response.token);
      //         localStorage.setItem('refreshToken', response.refreshToken);
      //         // Reintentar request original
      //         const retryReq = req.clone({
      //           setHeaders: {
      //             Authorization: `Bearer ${response.token}`,
      //             refreshToken: `${response.refreshToken}`,
      //             'Accept-Language': '"es-MX',
      //           },
      //         });

      //         return next(retryReq);
      //       }),
      //       catchError(() => {
      //         authService.logout();
      //         generalService.viewSnacAlert(
      //           'Tu sesión ha expirado, por favor inicia sesión nuevamente',
      //           'error',
      //           'Sesión expirada',
      //         );
      //         return throwError(() => error);
      //       }),
      //     );
      // }

      if (error.status === 401) {
        const refreshToken = localStorage.getItem('refreshToken');
        const token = localStorage.getItem('token');

        if (!isRefreshing) {
          isRefreshing = true;
          refreshTokenSubject.next(null);

          console.log('🔄 Intentando refrescar token...', req);

          if (req.url.includes('account/refresh')) {
            authService.logout();
            generalService.viewSnacAlert(
              'Tu sesión ha expirado, por favor inicia sesión nuevamente',
              'error',
              'Sesión expirada',
            );
          }

          return authService
            .refreshToken({
              token: token || '',
              refreshToken: refreshToken || '',
              isWeb: true,
            })
            .pipe(
              switchMap((response) => {
                isRefreshing = false;

                if (!response?.token) {
                  return throwError(() => error);
                }

                localStorage.setItem('token', response.token);
                localStorage.setItem('refreshToken', response.refreshToken);

                // 🔥 Despierta a las demás requests
                refreshTokenSubject.next(response.token);

                // 🔁 Reintentar request original (TU lógica intacta)
                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${response.token}`,
                    refreshToken: `${response.refreshToken}`,
                    'Accept-Language': '"es-MX',
                  },
                });

                return next(retryReq);
              }),
              catchError(() => {
                authService.logout();
                generalService.viewSnacAlert(
                  'Tu sesión ha expirado, por favor inicia sesión nuevamente',
                  'error',
                  'Sesión expirada',
                );
                isRefreshing = false;
                refreshTokenSubject.next(null);

                return throwError(() => error);
              }),
            );
        } else {
          // ⏳ Esperar a que el refresh termine
          return refreshTokenSubject.pipe(
            filter((token) => token != null),
            take(1),
            switchMap(() => {
              const newToken = localStorage.getItem('token');
              const newRefreshToken = localStorage.getItem('refreshToken');

              const retryReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${newToken}`,
                  refreshToken: `${newRefreshToken}`,
                  'Accept-Language': '"es-MX',
                },
              });

              return next(retryReq);
            }),
          );
        }
      }
      if (error.status === 403) {
        generalService.viewSnacAlert(error.error.message, 'alert', 'Acceso denegado');
      }

      if (error.status === 419) {
        authService.logout();
        generalService.viewSnacAlert(
          'Tu sesión ha expirado, por favor inicia sesión nuevamente',
          'error',
          'Sesión expirada',
        );
      }

      if (error.status === 500) {
        generalService.viewSnacAlert(
          'Error interno',
          'error',
          'Ha ocurrido un error en el servicio',
        );
      }

      return throwError(() => error);
    }),
  );
};
